import { useCallback, useEffect, useState } from 'react'

export const COLLAPSED_GROUPS_KEY = 'porotutu.react-nav-collapsed'

export function storedCollapsed(): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(COLLAPSED_GROUPS_KEY) ?? '[]')

    return Array.isArray(parsed)
      ? parsed.filter((key): key is string => typeof key === 'string')
      : []
  } catch {
    return []
  }
}

export function useCollapsedGroups() {
  const [collapsed, setCollapsed] = useState<string[]>(storedCollapsed)

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSED_GROUPS_KEY, JSON.stringify(collapsed))
    } catch {}
  }, [collapsed])

  const toggle = useCallback((key: string) => {
    setCollapsed((prev) =>
      prev.includes(key) ? prev.filter((other) => other !== key) : [...prev, key],
    )
  }, [])

  const isCollapsed = useCallback((key: string) => collapsed.includes(key), [collapsed])

  return { isCollapsed, toggle }
}
